import {SPECTRUM_HUB_DOMAIN} from "src/common/constants/constants";

export const isSpectrumHubSite = () => window.location.href.includes(SPECTRUM_HUB_DOMAIN);